export const GET_USER_BY_COGNITO_ID = 'GET_USER_BY_COGNITO_ID';
export const GET_USER_BY_COGNITO_ID_SUCCESS = 'GET_USER_BY_COGNITO_ID_SUCCESS';
export const GET_USER_BY_COGNITO_ID_FAILED = 'GET_USER_BY_COGNITO_ID_FAILED';

export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

export const RESET_USER_STATE = 'RESET_USER_STATE';

export const GET_TAGS = 'GET_TAGS';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAILED = 'GET_TAGS_FAILED';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILED = 'EDIT_USER_FAILED';

export const UPLOAD_PROFILE_PICTURE = 'UPLOAD_PROFILE_PICTURE';
export const UPLOAD_PROFILE_PICTURE_SUCCESS = 'UPLOAD_PROFILE_PICTURE_SUCCESS';
export const UPLOAD_PROFILE_PICTURE_FAILED = 'UPLOAD_PROFILE_PICTURE_FAILED';

export const GET_REGISTERED_VENUE_OWNERS = 'GET_REGISTERED_VENUE_OWNERS';
export const GET_REGISTERED_VENUE_OWNERS_SUCCESS = 'GET_REGISTERED_VENUE_OWNERS_SUCCESS';
export const GET_REGISTERED_VENUE_OWNERS_FAILED = 'GET_REGISTERED_VENUE_OWNERS_FAILED';

export const GET_USERS_RATING_BY_ROLE = 'GET_USERS_RATING_BY_ROLE';
export const GET_USERS_RATING_BY_ROLE_SUCCESS = 'GET_USERS_RATING_BY_ROLE_SUCCESS';
export const GET_USERS_RATING_BY_ROLE_FAILED = 'GET_USERS_RATING_BY_ROLE_FAILED';

export const DELETE_USER_RATING = 'DELETE_USER_RATING';
export const DELETE_USER_RATING_SUCCESS = 'DELETE_USER_RATING_SUCCESS';
export const DELETE_USER_RATING_FAILED = 'DELETE_USER_RATING_FAILED';

export const GET_VENDOR_USERS = 'GET_VENDOR_USERS';
export const GET_VENDOR_USERS_SUCCESS = 'GET_VENDOR_USERS_SUCCESS';
export const GET_VENDOR_USERS_FAILED = 'GET_VENDOR_USERS_FAILED';
export const ON_SEARCH_VENDOR_USER = 'ON_SEARCH_VENDOR_USER';

export const GET_USERS_VENUE_VENDORS = 'GET_USERS_VENUE_VENDORS';
export const GET_USERS_VENUE_VENDORS_SUCCESS = 'GET_USERS_VENUE_VENDORS_SUCCESS';
export const GET_USERS_VENUE_VENDORS_FAILED = 'GET_USERS_VENUE_VENDORS_FAILED';
export const ON_SEARCH_USERS = 'ON_SEARCH_USERS';

export const DISABLE_USER_BY_TERMS_ANDS_CONDITIONS = 'DISABLE_USER_BY_TERMS_ANDS_CONDITIONS';
export const DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS =
  'DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS';
export const DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED =
  'DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED';

export const GET_VENDORS_BY_VENUE = 'GET_VENDORS_BY_VENUE';
export const GET_VENDORS_BY_VENUE_SUCCESS = 'GET_VENDORS_BY_VENUE_SUCCESS';
export const GET_VENDORS_BY_VENUE_FAILED = 'GET_VENDORS_BY_VENUE_FAILED';

export const CREATE_USER_ASSET = 'CREATE_USER_ASSET';
export const CREATE_USER_ASSET_SUCCESS = 'CREATE_USER_ASSET_SUCCESS';
export const CREATE_USER_ASSET_FAILED = 'CREATE_USER_ASSET_FAILED';

export const UPDATE_USER_ASSET = 'UPDATE_USER_ASSET';
export const UPDATE_USER_ASSET_SUCCESS = 'UPDATE_USER_ASSET_SUCCESS';
export const UPDATE_USER_ASSET_FAILED = 'UPDATE_USER_ASSET_FAILED';

export const DELETE_USER_ASSET = 'DELETE_USER_ASSET';
export const DELETE_USER_ASSET_SUCCESS = 'DELETE_USER_ASSET_SUCCESS';
export const DELETE_USER_ASSET_FAILED = 'DELETE_USER_ASSET_FAILED';

export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILED = 'GET_USER_BY_ID_FAILED';
